import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faLanguage, faToolbox, faHeart, faBriefcase, faGraduationCap, faLink } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin, faYoutube, faUpwork, faTelegram, faFacebook, faTwitter, faInstagram, faMedium, faBehance, faDribbble, faStackOverflow, faAngellist, faQuora, faVimeo, faSoundcloud } from '@fortawesome/free-brands-svg-icons';

import '../styles/TemplateTen.css';

const TemplateTen = ({ template, onClick }) => {
    const linkIcons = {
        github: faGithub,
        linkedin: faLinkedin,
        youtube: faYoutube,
        upwork: faUpwork,
        telegram: faTelegram,
        facebook: faFacebook,
        website: faMapMarkerAlt,
        portfolio: faMapMarkerAlt, // Assume generic link icon
        twitter: faTwitter,
        instagram: faInstagram,
        medium: faMedium,
        behance: faBehance,
        dribbble: faDribbble,
        stackoverflow: faStackOverflow,
        angellist: faAngellist,
        quora: faQuora,
        vimeo: faVimeo,
        soundcloud: faSoundcloud,
        blog: faLink,         // Assume generic link icon
        researchgate: faLink, // Assume generic link icon
        devto: faLink        // Assume generic link icon
    };

    const linkText = {
        github: 'GitHub',
        linkedin: 'LinkedIn',
        youtube: 'YouTube',
        upwork: 'Upwork',
        telegram: 'Telegram',
        facebook: 'Facebook',
        website: 'Website',
        portfolio: 'Portfolio',
        twitter: 'Twitter',
        instagram: 'Instagram',
        medium: 'Medium',
        behance: 'Behance',
        dribbble: 'Dribbble',
        stackoverflow: 'Stack Overflow',
        angellist: 'AngelList',
        quora: 'Quora',
        vimeo: 'Vimeo',
        soundcloud: 'SoundCloud',
        blog: 'Blog',
        researchgate: 'ResearchGate',
        devto: 'Dev.to'
    };

    // Ensure links are an array
    const links = Array.isArray(template?.links) ? template.links : [];

    return (
        <div className="template-ten-container" onClick={() => onClick(template?.id)}>
            <div className="template-ten" >
                <div className="template-ten-header" >
                    <div>
                        {template?.image && <img src={template?.image} alt={template?.personName} className="template-ten-image" />}
                    </div>
                    <div className="template-ten-name-title">
                        {template?.name && <h1 className="template-ten-name" style={{ color: 'white' }}>{template?.name}</h1>}
                    </div>
                </div>
                <div className="template-ten-body" >
                    <div className="template-ten-left" >

                        {template.contact && (
                            <div className="template-ten-section" >
                                <h3>Contact</h3>
                                {template.contact.phone && <p><FontAwesomeIcon icon={faPhone} /> {template.contact.phone}</p>}
                                {template.contact.email && <p><FontAwesomeIcon icon={faEnvelope} /> {template.contact.email}</p>}
                                {template.contact.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} /> {template.contact.address}</p>}
                            </div>
                        )}


                        {template?.skills && template?.skills.length > 0 && (
                            <div className="template-ten-section">
                                <h3 >Skills</h3>
                                <ul>
                                    {template?.skills.map((skill, index) => (
                                        <li key={index}>{skill}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {template.softwareSkills && (
                            <div className="template-ten-section">
                                <h3>Software Skills</h3>
                                <ul>
                                    {template.softwareSkills?.map((software, index) => (
                                        <li key={index}>{software}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {template?.languages && template?.languages.length > 0 && (
                            <div className="template-ten-section">
                                <h3 >Languages</h3>
                                <ul>
                                    {template?.languages?.map((language, index) => (
                                        <li key={index}>{language}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                    </div>
                    <div className="template-ten-center">
                        {template?.aboutMe && (
                            <div className="template-ten-section">
                                <h3 >Profile</h3>
                                <p>{template?.aboutMe}</p>
                            </div>
                        )}
                        {template?.workExperience && template?.workExperience.length > 0 && (
                            <div className="template-ten-section">
                                <h3 >Work Experience</h3>
                                {template?.workExperience?.map((experience, index) => (
                                    <div key={index} className="template-ten-experience-item">
                                        <p className="template-ten-role" >{experience.role}</p>
                                        <p className="template-ten-company-location">{experience.company} / {experience.location}</p>
                                        <p className="template-ten-date">
                                            {experience.location && (
                                                <p className="location">
                                                    (
                                                    {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                                    {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                                    )
                                                </p>
                                            )}
                                        </p>
                                        <p className="template-ten-description">{experience.description}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                        {template?.education && template?.education.length > 0 && (
                            <div className="template-ten-section">
                                <h3 >Education</h3>
                                {template?.education?.map((edu, index) => (
                                    <div key={index} className="template-ten-education-item">
                                        <p className="template-ten-degree">{edu.degree}</p>
                                        <p className="template-ten-institution">{edu.institution}</p>
                                        <p>
                                            (
                                            {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                            {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                            )
                                        </p>
                                        <p className="view-template-eight-institution">{edu.description}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="template-ten-right">

                        {template?.certificates && template?.certificates.length > 0 && (
                            <div className="template-ten-section">
                                <h3 >Certificates</h3>
                                <ul>
                                    {template?.certificates?.map((certificate, index) => (
                                        <div key={index} className="template-ten-certificate-item">
                                            <p className="template-ten-title">Title: {certificate.title}</p>
                                            <p className="template-ten-institution">Institution: {certificate.institution}</p>
                                            <p className="template-ten-date">
                                                Date Received: {new Date(certificate.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                            </p>
                                        </div>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {template?.hobbies && template?.hobbies.length > 0 && (
                            <div className="template-ten-section">
                                <h3 >Hobbies</h3>
                                <ul>
                                    {template?.hobbies.map((hobby, index) => (
                                        <li key={index}>{hobby}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {template?.links && template?.links.length > 0 && (
                            <div className="template-ten-section">
                                <h3>Links:</h3>
                                <ul>
                                    {template.links.map(([key, value]) => (
                                        <li key={key}>
                                            <FontAwesomeIcon icon={linkIcons[key] || faLink} /> <a href={value} target="_blank" rel="noopener noreferrer" style={{color:"white"}}>{linkText[key]}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}


                    </div>
                </div>
            </div>

        </div>
    );
};

export default TemplateTen;
